import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import '../styles.less'
import ManagerCommentWidget from '../../../widgets/progressReportWidget/ManagerCommentWidget'
import AcknowledgementWidget from '../../../widgets/progressReportWidget/AcknowledgementWidget'
import IntroductionWidget from '../../../widgets/progressReportWidget/IntroductionWidget'
import OperationalProgressWidget from '../../../widgets/progressReportWidget/OperationalProgressWidget'
import ProgessActivityWidget from '../../../widgets/progressReportWidget/ProgessActivityWidget'
import ProgessProductWidget from '../../../widgets/progressReportWidget/ProgessProductWidget'
import ProgessOutcomeWidget from '../../../widgets/progressReportWidget/ProgessOutcomeWidget'
import ProgressIndicatorWidget from '../../../widgets/progressReportWidget/ProgressIndicatorWidget'
import ProgessResultWidget from '../../../widgets/progressReportWidget/ProgessResultWidget'
import PercentOfProgressWidget from '../../../widgets/progressReportWidget/PercentOfProgressWidget'
import ProblemsAndSolutionWidget from '../../../widgets/progressReportWidget/ProblemsAndSolutionWidget'
import RiskAssessmentWidget from '../../../widgets/progressReportWidget/RiskAssessmentWidget'
import SearchTagWidget from '../../../widgets/progressReportWidget/SearchTagWidget'
import TargetGroupAndAreaWidget from '../../../widgets/progressReportWidget/TargetGroupAndAreaWidget'
import WorkSummaryWidget from '../../../widgets/progressReportWidget/WorkSummaryWidget'
import AttachFilesWidget from '../../../widgets/progressReportWidget/AttachFilesWidget'
import LearningCenterView from '../../../widgets/progressReportWidget/LearningCenterView'
import CertificationCPAWidget from '../../../widgets/progressReportWidget/withdraw/CertificationCPAWidget'
import ExpenditureReportWidget from '../../../widgets/progressReportWidget/withdraw/ExpenditureReportWidget'
import WithdrawRequestWidget from '../../../widgets/progressReportWidget/withdraw/WithdrawRequestWidget'
import {
  getVenderRequestForm,
  getWithdrawRequestForm,
} from '../../../redux/actions/withdrawRequest'
import { startLoading, doneLoading } from '../../../utils/loading'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import AgreementAdditionalWidgets from '../../../widgets/agreementAdditional/AgreementAdditionalWidgets'
import WithdrawRequestWithProgressWidget from '../../../widgets/progressReportWidget/withdraw/WithdrawRequestWithProgressWidget'
import InfomaUploadFilesWidget from '../../../widgets/infomaWidget/InfomaUploadFilesWidget'
import EFormUploadFilesWidget from '../../../widgets/eFormFilesWidget/EFormUploadFilesWidget'
import ConfirmActualResultWidget from '../../../widgets/confirmActualResultWidget/ConfirmActualResultWidget'
import scrollToComponent from 'react-scroll-to-component'

export default function WithdrawRequest(props) {
  const [isEditAll, setIsEditAll] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [schemas, setSchemas] = useState()
  const [error, setError] = useState()
  const [paymentSchema, setPaymentSchema] = useState()
  const [withdrawRequestStatusSchema, setWithdrawRequestStatusSchema] = useState()
  const [requestId, setRequestId] = useState()
  const [isEditAttachment, setIsEditAttachment] = useState(false)
  const [isValidateEFormFile, setIsValidateEFormFile] = useState(false)
  const [eFormFiles, setEFormFiles] = useState([])

  const [confirmActualResulSchema, setConfirmActualResulSchema] = useState()
  const [confirmActualResulChecked, setConfirmActualResulChecked] = useState()

  // confirmActualResul
  //const projectId = useSelector((state) => state.getParameter?.projectId)

  const [vendorRequest, setVendorRequest] = useState()
  const [overBudgetMessage, setOverBudgetMessage] = useState()
  const [isHasOverBudgetFile, setIsHasOverBudgetFile] = useState()
  const [eFormFileSection, setEFormFileSection] = useState()

  const projectId = sessionStorage.getItem('projectId')
  let request_Id = sessionStorage.getItem('param')?.substring(1)

  // useEffect(() => {
  //   console.log('load ProgressReport project_id: ', projectId, 'request_id: ', request_Id)
  //   setRequestId(request_Id)
  //   handleGetSchema(projectId, request_Id)
  // }, [])

  useEffect(() => {
    setRequestId(request_Id)
    handleGetSchema(projectId, request_Id)
  }, [request_Id, projectId])

  useEffect(() => {
    if (
      schemas?.forms?.eFormFile?.forms?.attachFiles?.value &&
      schemas?.forms?.eFormFile?.forms?.attachFiles?.value.length > 0
    ) {
      setEFormFiles(schemas?.forms?.eFormFile?.forms?.attachFiles?.value || [])
      
      var file = schemas?.forms?.eFormFile?.forms?.attachFiles?.value.find(i => i.documentId == '2777' || i.documentId == '9777')
      if(file != null && file.isRequired){
        setOverBudgetMessage('มีเงินคงเหลือเกิน 50% ของเงินงวดถัดไป ' + file.description) //มีเงินคงเหลือเกิน 50% ของเงินงวดถัดไป ต้อง แนบแผนปฏิบ้ติการการใช้จ่ายงบประมาณในงวดถัดไป
      }
    }
  }, [schemas])

  useEffect(() => {
    if (eFormFiles && eFormFiles.length > 0) {
      let validate = true
      eFormFiles.forEach((item, index) => {
        console.log('item', item)
        if (item.isRequired && !item.documentFilePath) {
          validate = false
        }

        if (item.documentId == '2777' || item.documentId == '9777') {
          if(item.isRequired && item.documentFilePath){
            setIsHasOverBudgetFile('แนบไฟล์ ' + item.documentName + ' สำเร็จ')
          }else {
            setIsHasOverBudgetFile(null)
          }
         
        }
      })
      setIsValidateEFormFile(validate)
    }
  }, [eFormFiles])

  const handleGetSchema = async (projectId, requestId) => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getWithdrawRequestForm(projectId, requestId)

      console.log('handleGetSchema', _schema)
      setSchemas(_schema)
      setConfirmActualResulSchema(_schema?.forms?.confirmActualResul)
      setConfirmActualResulChecked(_schema?.forms?.confirmActualResul?.confirmActualResulChecked)

      // await handleGetVendorRequestSchema(projectId, requestId)
      // setSchemas(mockSchema)

      //const payment = await getPaymentCheck(projectId)

      // const response = await getWithdrawRequestBudget(projectId, requestId)
      // console.log('PaymentSchema', response)
      // setPaymentSchema(response)

      // const _withdrawRequestStatus = await getWithdrawRequestStatus(projectId)
      // setWithdrawRequestStatusSchema(_withdrawRequestStatus)

      setError()
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleRefreshSchema = async () => {
    startLoading()
    try {
      let requestId = sessionStorage.getItem('param')?.substring(1)
      const _schema = await getWithdrawRequestForm(projectId, requestId)

      setConfirmActualResulSchema(_schema?.forms?.confirmActualResul)
      setConfirmActualResulChecked(_schema?.forms?.confirmActualResul?.confirmActualResulChecked)

      console.log('handleGetSchema', _schema)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schemas || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <>
      <SidebarProposal>
        <ContentHeader header={schemas.header} subHeader={schemas.subHeader} />

        {/* <BtnEditAll onClickEditAll={isEditAll} setOnClickEditAll={setIsEditAll} /> */}

        {schemas?.forms?.requestedDetails && (
          <AgreementAdditionalWidgets
            showCommandButton={true}
            formSchema={schemas.forms.requestedDetails}
            preContentLabel={'ความคิดเห็นของผู้อนุมัติ : '}
          />
        )}

        {/* ความก้าวหน้าในการดำเนินงาน */}
        {schemas?.forms?.operationalProgress && (
          <>
            <OperationalProgressWidget schema={schemas.forms.operationalProgress} />
            <br />
          </>
        )}

        {/* กิตติกรรมประกาศ */}
        {schemas?.forms?.acknowledgement && (
          <>
            <AcknowledgementWidget schema={schemas.forms.acknowledgement} />
            <br />
          </>
        )}

        {/* คำนำ */}
        {schemas?.forms?.introduction && (
          <>
            <IntroductionWidget schema={schemas.forms.introduction} />
            <br />
          </>
        )}

        {/* สรุปความเห็นผู้บริหาร */}
        {schemas?.forms?.managerComment && (
          <>
            <ManagerCommentWidget schema={schemas.forms.managerComment} />
            <br />
          </>
        )}

        {/* ผลการดำเนินการ (กิจกรรม) */}
        {schemas?.forms?.progessActivity && (
          <>
            <ProgessActivityWidget schema={schemas.forms.progessActivity} />
            <br />
          </>
        )}

        {/* ผลผลิตที่เกิดขึ้นจริง */}
        {schemas?.forms?.progessProduct && (
          <>
            <ProgessProductWidget schema={schemas.forms.progessProduct} />
            <br />
          </>
        )}

        {/* ตัวชี้วัด */}
        {schemas?.forms?.progressIndicator && (
          <>
            <ProgressIndicatorWidget
              schema={schemas.forms.progressIndicator}
              showConnectionButton={
                schemas.forms.withdrawRequestWithProgressByCoordinator?.enableEdit || false
              }
              isWithdrawRequest={true}
            />
            <br />
          </>
        )}

        {/* ผลลัพธ์ */}
        {schemas?.forms?.progessOutcome && (
          <>
            <ProgessOutcomeWidget schema={schemas.forms.progessOutcome} />
            <br />
          </>
        )}

        {/* ผลลัพธ์หรือแนวทาง/วิธีการในการขยายผล/ผลที่คาดว่าจะได้รับ */}
        {schemas?.forms?.progessResult && (
          <>
            <ProgessResultWidget schema={schemas.forms.progessResult} />
            <br />
          </>
        )}

        {/* องค์กรภาคีเครือข่ายที่สนับสนุนกิจกรรม */}
        {/* {schemas?.forms?.networkAndOrganiation && (
          <>
            <NetworkAndOrganiationView schema={schemas.forms.networkAndOrganiation} />
            <br />
          </>
        )} */}

        {/* แหล่งเรียนรู้ */}
        {schemas?.forms?.learningCenter && (
          <>
            <LearningCenterView schema={schemas.forms.learningCenter} />
            <br />
          </>
        )}

        {/* การประเมินความสำเร็จของโครงการร้อยละ */}
        {schemas?.forms?.percentOfProgress && (
          <>
            <PercentOfProgressWidget schema={schemas.forms.percentOfProgress} />
            <br />
          </>
        )}

        {/* ปัญหาอุปสรรคที่พบพร้อมแนวทางแก้ไข */}
        {schemas?.forms?.problemsAndSolution && (
          <>
            <ProblemsAndSolutionWidget schema={schemas.forms.problemsAndSolution} />
            <br />
          </>
        )}

        {/* การประเมินความเสี่ยง */}
        {schemas?.forms?.riskAssessment && (
          <>
            <RiskAssessmentWidget schema={schemas.forms.riskAssessment} />
            <br />
          </>
        )}
        {/* คำค้น */}
        {schemas?.forms?.searchTag && (
          <>
            <SearchTagWidget schema={schemas.forms.searchTag} />
            <br />
          </>
        )}

        {/* กลุ่มเป้าหมายและพื้นที่ในการดำเนินการ */}
        {schemas?.forms?.targetGroup && (
          <>
            <TargetGroupAndAreaWidget schema={schemas.forms.targetGroup} />
            <br />
          </>
        )}

        {/* สรุปผลงาน */}
        {schemas?.forms?.workSummary && (
          <>
            <WorkSummaryWidget schema={schemas.forms.workSummary} />
            <br />
          </>
        )}

        {/* ไฟล์แนบ */}
        {schemas?.forms?.attachments && (
          <>
            <AttachFilesWidget
              showCommandButton={schemas.forms.withdrawRequestWithProgressByCoordinator?.enableEdit}
              schema={schemas.forms.attachments}
              isEdit={isEditAttachment}
              onChangeIsEdit={(_isEdit) => setIsEditAttachment(_isEdit)}
            />
            <br />
          </>
        )}

        {/* ครุภัณฑ์โครงการ */}
        {/* {schemas?.forms?.progressAsset && (
          <>
            <ProgressAssetWidget schema={schemas.forms.progressAsset} />
            <br />
          </>
        )} */}

        {/* แนบไฟล์ รายงานการใช้จ่ายเงินโครงการ */}
        {schemas?.forms?.expendingReport && (
          <>
            <ExpenditureReportWidget
              showCommandButton={
                schemas.forms.expendingReport.enableEdit ||
                schemas.forms.withdrawRequestWithProgressByCoordinator?.enableEdit
              }
              isEditAll={isEditAll}
              schema={schemas.forms.expendingReport}
              isRequiredCPA={schemas.forms.certificationCPA ? true : false}
              onSuccess={(res) =>
                setSchemas((state) => ({
                  ...state,
                  forms: {
                    ...state.forms,
                    expendingReport: {
                      ...state.forms.expendingReport,
                      attachFiles: {
                        ...state.forms.expendingReport.attachFiles,
                        value: res,
                      },
                    },
                  },
                }))
              }
            />
            <br />
          </>
        )}

        {/* แนบไฟล์ CPA */}
        {schemas?.forms?.certificationCPA && (
          <>
            <CertificationCPAWidget
              showCommandButton={
                schemas.forms.certificationCPA.enableEdit ||
                schemas.forms.withdrawRequestWithProgressByCoordinator?.enableEdit
              }
              isEditAll={isEditAll}
              schema={schemas.forms.certificationCPA}
              onSuccess={(res) =>
                setSchemas((state) => ({
                  ...state,
                  forms: {
                    ...state.forms,
                    certificationCPA: {
                      ...state.forms.certificationCPA,
                      attachFiles: {
                        ...state.forms.certificationCPA.attachFiles,
                        value: res,
                      },
                    },
                  },
                }))
              }
            />
            <br />
          </>
        )}

        {/* รายงานสรุปประกอบการขออนุมัติเบิกเงิน */}
        {schemas?.forms?.withdrawRequestWithProgressByCoordinator && (
          <>
            <WithdrawRequestWithProgressWidget
              showCommandButton={schemas.forms.withdrawRequestWithProgressByCoordinator.enableEdit}
              isInitial={schemas.forms.withdrawRequestWithProgressByCoordinator.id ? false : true}
              schema={schemas.forms.withdrawRequestWithProgressByCoordinator}
            />
            <br />
          </>
        )}

        {/* แนบไฟล์ eform */}
        {schemas?.forms?.eFormFile && (
          <div ref={(section) => setEFormFileSection(section)}>
            <EFormUploadFilesWidget
              disabledForm={!schemas.forms.eFormFile.enableEdit}
              schema={schemas.forms.eFormFile.forms}
              requestId={requestId}
              onUploadSuccess={(e) => setEFormFiles(e)}
            />
            <br />
          </div>
        )}

        {/* ยืนยันผลการดำเนินการจริง */}
        {confirmActualResulSchema &&
          schemas?.forms?.confirmActualResul?.numberOfInstallment != 9999 && (
            <>
              <ConfirmActualResultWidget
                // schema={schemas?.forms?.confirmActualResul}
                // checked={schemas?.forms?.confirmActualResul?.confirmActualResulChecked}
                isEdit={!schemas.forms.withdrawRequest}
                schema={confirmActualResulSchema}
                checked={confirmActualResulChecked}
                numberOfInstallment={schemas?.forms?.confirmActualResul?.numberOfInstallment || 0}
                onSuccess={(fag) => {
                  if (fag) {
                    // let requestId = sessionStorage.getItem('param')?.substring(1)
                    // handleGetSchema(projectId, requestId)
                    handleRefreshSchema()
                  }
                }}
              />
            </>
          )}

        {/* ขอเบิกงวดเงิน */}
        {/* {schemas?.forms?.withdrawRequest && (
          <> */}
        <WithdrawRequestWidget
          showCommandButton={true}
          isEditAll={isEditAll}
          schema={schemas.forms.withdrawRequest}
          hidePreview={schemas.forms.disablePreview}
          expenditureReport={schemas.forms.expendingReport}
          //isRequiredCPA={schemas.forms.certificationCPA ? true : false}
          certificationCPA={schemas.forms.certificationCPA}
          //schema={withdrawRequest}
          //bankAccount={schemas.forms.withdrawAuthorized.bankAccount}
          isFinalWithdraw={schemas.forms.isFinalWithdraw}
          withdrawFile={schemas.forms.withdrawFile}
          isValidateEFormFile={isValidateEFormFile}
          eFormHeader={schemas?.forms?.eFormFile?.header || 'เอกสารประกอบการเบิกเงินงวด'}
          // informational={schemas?.messageRequestInformational || null}
          informational={schemas?.messageRequestInformational || null}
          // statusConfirmActualResult={
          //   schemas?.forms?.confirmActualResul?.confirmActualResulChecked?.overAll
          // }
          statusConfirmActualResult={confirmActualResulChecked?.overAll}
          overBudgetMessage={overBudgetMessage}
          handleGotoEformFile={()=> {scrollToComponent(eFormFileSection, { offset: 0, align: 'top', duration: 500 })}}
          isHasOverBudgetFile={isHasOverBudgetFile}
        />

        <br />
        {/* </>
        )} */}

        {/* ข้อมูลบัญชีและผู้มีอำนาจลงนามเบิกจ่าย */}
        {/* {schemas?.forms?.withdrawAuthorized && (
          <>
            <WithdrawAuthorizedWidget schema={schemas.forms.withdrawAuthorized} />
            <br />
          </>
        )} */}

        {/* ย้ายไปไว้ SendWithdrawRequest.js (หน้านักวิชาการ เสนอพิจารณาอนุมัติขอเบิกเงินงวด) */}
        {/* งบประมาณโครงการ และ งวดเบิกจ่าย */}
        {/* <Budget
          schema={paymentSchema?.forms}
          isEditable={!paymentSchema?.disabled}
          defaultExpandAllRows={true}
          isShowBudgetSubmitButton={false}
          isCollapseAllTableRow={false}
          isHideBudgetPlan={true}
          isHidePeriodExpenses
          isHideBudgetInstallmentPlan
          //onClickConfirmBudget={handleConfirmBudget}
          withdrawRequestStatusSchema={withdrawRequestStatusSchema}
          isWithdraw={true}
          requestId={requestId}
        />
        <br /> */}
      </SidebarProposal>
    </>
  )
}

const mockSchema = {
  affectedRows: 0,
  message: 'Successfully',
  success: true,
  didError: false,
  errorMessage: null,
  model: {
    header: 'การเชื่อมโยงเพื่อจัดเก็บในระบบ INFOMA',
    forms: {
      disabled: false,
      attachFiles: {
        name: 'attachFiles',
        header: ' ',
        value: [
          {
            id: '1',
            category: '01-กลั่นกรองและอนุมัติโครงการ',
            children: [
              {
                id: '886C2EF8-47F4-4D51-B457-F2640ABAE68E',
                documentId: '1011',
                documentName: 'ข้อเสนอโครงการ',
                documentFileName: 'ข้อเสนอโครงการ-65-10150',
                documentFilePath: 'files/proposal/C3560176-2653-45D3-8470-CF467299C0C5.pdf',
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: '1',
                documentStatusName: 'ส่งสำเร็จ',
                masterCategoryId: '1',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-521DB6DB-93D5-408A-BD3A-0FA7069E',
                documentId: '1012',
                documentName: 'หลักฐานประกอบการยื่นข้อเสนอ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '1',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-DA13B395-8877-450D-A5E2-10FD818B',
                documentId: '1013',
                documentName: 'แบบยืนยันการไม่มีส่วนได้ส่วนเสีย อ.7',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '1',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-B2BBCAF8-9467-4ABD-B61D-14119B7E',
                documentId: '1014',
                documentName: 'แบบกลั่นกรองโครงการ อ.8',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '1',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-140BD920-CB82-44F1-A7D2-B72F7F62',
                documentId: '1015',
                documentName: 'รายงานการประชุมคณะกรรมการพิจารณาโครงการ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '1',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-BA14D823-44DD-4F5A-8185-2240307B',
                documentId: '1016',
                documentName: 'แบบสรุปรายงานการพิจารณาโครงการ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '1',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'E9F2B3DE-32BC-48D2-B103-C8FA6383E00C',
                documentId: '1017',
                documentName: 'แบบขออนุมัติและจัดทำสัญญา อ.10',
                documentFileName: 'แบบขออนุมัติและจัดทำสัญญา.pdf',
                documentFilePath: 'files/request-approve/C6444836-E7A9-48EA-9BA6-1388D41B39C5.pdf',
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: '1',
                documentStatusName: 'ส่งสำเร็จ',
                masterCategoryId: '1',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'F6F31859-2691-4178-93FA-9971DA1F9940',
                documentId: '1018',
                documentName: 'รายงานสรุปกรณีมีส่วนได้เสียของโครงการ อ.11',
                documentFileName: 'รายงานสรุปกรณีมีส่วนเกี่ยวข้องหรือส่วนได้เสีย.pdf',
                documentFilePath: 'files/stake-holders/F20113A0-90CD-4E6C-89CF-36390AFB9564.pdf',
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: '1',
                documentStatusName: 'ส่งสำเร็จ',
                masterCategoryId: '1',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-100D7448-5987-485B-9AE9-7E33A1D1',
                documentId: '1099',
                documentName: 'แนบเอกสารอื่นเพิ่มเติม',
                documentFileName: null,
                documentFilePath: null,
                documentType: '9',
                documentTypeName: 'แนบเพิ่มเติม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '1',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'last',
                documentId: '1099',
                documentName: '',
                documentFileName: '',
                documentFilePath: '',
                documentType: '',
                documentTypeName: '',
                documentStatusCode: '',
                documentStatusName: '',
                masterCategoryId: '1',
                isEdit: false,
                isLastRow: true,
              },
            ],
          },
          {
            id: '2',
            category: '02-การจัดทำข้อตกลง',
            children: [
              {
                id: 'add-32348688-8C63-4BDD-A8A6-EABF3549',
                documentId: '2011',
                documentName: 'ข้อตกลง / สัญญา (กระดาษ/อิเล็กทรอนิกส์)',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '2',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-E8016F2E-4BEE-4F40-90CE-5D338C67',
                documentId: '2012',
                documentName: 'หลักฐานประกอบการทำสัญญา(เพิ่มเติม)',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '2',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-9483208B-D2C1-4A82-8267-633E1101',
                documentId: '2013',
                documentName: 'ข้อเสนอโครงการ',
                documentFileName: 'ข้อเสนอโครงการ-65-10150',
                documentFilePath: 'files/proposal/C3560176-2653-45D3-8470-CF467299C0C5.pdf',
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '2',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-89A823A8-501B-4173-ABA5-04B278D6',
                documentId: '2016',
                documentName: 'หนังสือรับรองการรับทุน',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '2',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-87469A5D-C9A6-4C46-9B00-831F6523',
                documentId: '2017',
                documentName: 'หน้า Bookbank',
                documentFileName: null,
                documentFilePath: null,
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '2',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-C42D95E6-CA82-4035-8D11-D7C64BE7',
                documentId: '2018',
                documentName: 'การชำระอากรแสตมป์',
                documentFileName: null,
                documentFilePath: null,
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '2',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-9FED4561-3717-49B6-A231-1AB694D1',
                documentId: '2088',
                documentName: 'เอกส่ารแนบประกอบอื่น',
                documentFileName: null,
                documentFilePath: null,
                documentType: '9',
                documentTypeName: 'แนบเพิ่มเติม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '2',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-DF824876-4E90-4ECE-88E6-538C9442',
                documentId: '2099',
                documentName: 'แนบเอกสารอื่นเพิ่มเติม',
                documentFileName: null,
                documentFilePath: null,
                documentType: '9',
                documentTypeName: 'แนบเพิ่มเติม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '2',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'last',
                documentId: '2099',
                documentName: '',
                documentFileName: '',
                documentFilePath: '',
                documentType: '',
                documentTypeName: '',
                documentStatusCode: '',
                documentStatusName: '',
                masterCategoryId: '2',
                isEdit: false,
                isLastRow: true,
              },
            ],
          },
          {
            id: '3',
            category: '03-การแก้ไขข้อตกลง',
            children: [
              {
                id: 'add-D3CB932E-03CB-4639-A58A-576A2021',
                documentId: '3011',
                documentName: 'ข้อตกลง / สัญญา (ฉบับแก้ไข)(กระดาษ/อิเล็กทรอนิกส์)',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '3',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-E3564F30-F2C3-4108-B402-B9FBD86D',
                documentId: '3012',
                documentName: 'หนังสือขอแก้ไข (จากภาคี)',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '3',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-54F016BE-4910-4338-A319-999BB1EA',
                documentId: '3013',
                documentName: 'หนังสือมอบอำนาจ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '3',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-391E3E43-1D48-4484-A32A-00FA2127',
                documentId: '3014',
                documentName: 'หนังสือแต่งตั้งผู้รับผิดชอบโครการ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '3',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-5FD4D9B9-E572-441A-A70D-A6F62ED9',
                documentId: '3015',
                documentName: 'คำสั่งแต่งตั้ง',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '3',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-AD464FAB-4C87-4EE3-B01B-9BBC56F8',
                documentId: '3016',
                documentName: 'สำนาบัตรประชาชน',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '3',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-49E1A5C0-D86A-4617-9C4E-3AA0EA56',
                documentId: '3088',
                documentName: 'เอกส่ารแนบประกอบอื่น',
                documentFileName: null,
                documentFilePath: null,
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '3',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-177FE0C0-A285-4074-BCBD-9C2A2177',
                documentId: '3099',
                documentName: 'แนบเอกสารอื่นเพิ่มเติม',
                documentFileName: null,
                documentFilePath: null,
                documentType: '9',
                documentTypeName: 'แนบเพิ่มเติม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '3',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'last',
                documentId: '3099',
                documentName: '',
                documentFileName: '',
                documentFilePath: '',
                documentType: '',
                documentTypeName: '',
                documentStatusCode: '',
                documentStatusName: '',
                masterCategoryId: '3',
                isEdit: false,
                isLastRow: true,
              },
            ],
          },
          {
            id: '4',
            category: '04-การเบิกเงิน งวดที่ N',
            children: [
              {
                id: 'add-CF6D1F35-C2CF-403F-AFEF-49EFB427',
                documentId: '4111',
                documentName: 'รายงานการเงิน งวดก่อนหน้า ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-67BD98D7-79C1-4FE7-B13C-1624F0A3',
                documentId: '4112',
                documentName: 'แบบขอเบิกเงินโครงการ f-008     ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-84C1E769-CA4C-463A-BEF0-5B8B204C',
                documentId: '4113',
                documentName: 'แบบขออนุมัติและจัดทำสัญญา อ.10',
                documentFileName: 'แบบขออนุมัติและจัดทำสัญญา.pdf',
                documentFilePath: 'files/request-approve/C6444836-E7A9-48EA-9BA6-1388D41B39C5.pdf',
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-99B0EA87-C67B-4BCC-8C75-12517844',
                documentId: '4114',
                documentName: 'หน้าบุ๊คแบงค์  ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-87BB61CF-ECC4-4B09-AE26-7F90A4E2',
                documentId: '4115',
                documentName: 'ขอนำส่งเอกสารรับรองการตรวจสอบเงินงวดโครงการ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-467F3499-EAA7-4AFC-A179-4C632F5E',
                documentId: '4116',
                documentName: 'รายงานสรุปประกอบการขออนุมัติเบิกเงินงวดนั้น ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-9052EB9A-C9A7-47CD-958E-C2F36326',
                documentId: '4117',
                documentName: 'Teller Payment',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-5A1381B6-FAFB-4402-B53C-AAEB10C3',
                documentId: '4118',
                documentName: 'แผนการใช้จ่ายงบประมาณ ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-AF52BE87-A331-476E-B468-3AE1204E',
                documentId: '4119',
                documentName: 'หลักฐานการได้รับยกเว้นภาษี ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-8C7A6F6B-81D2-43F3-A93A-1DA7F132',
                documentId: '4120',
                documentName: 'ใบทะเบียนภาษีมูลค่าเพิ่ม ภพ.20',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-CD38D4B5-7F7D-46B0-A731-90F02F6D',
                documentId: '4121',
                documentName: 'ใบ PV (1 PV เบิกจ่ายหลายโครงการ/หลายสำนัก) ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-62E4E634-DEAD-4834-A87B-143D081D',
                documentId: '4122',
                documentName: 'ใบสำคัญตั้งหนี้บริหารโครงการ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-AAD8994F-1772-4FCE-838F-8C185BD2',
                documentId: '4188',
                documentName: 'เอกสารแนบประกอบรายงานอื่น',
                documentFileName: null,
                documentFilePath: null,
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-7C2F011D-4B6E-43A8-9FC1-81750DB7',
                documentId: '4199',
                documentName: 'แนบเอกสารอื่นเพิ่มเติม',
                documentFileName: null,
                documentFilePath: null,
                documentType: '9',
                documentTypeName: 'แนบเพิ่มเติม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '4',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'last',
                documentId: '4199',
                documentName: '',
                documentFileName: '',
                documentFilePath: '',
                documentType: '',
                documentTypeName: '',
                documentStatusCode: '',
                documentStatusName: '',
                masterCategoryId: '4',
                isEdit: false,
                isLastRow: true,
              },
            ],
          },
          {
            id: '5',
            category: '05-การเปลี่ยนแปลง/ขยายเวลา',
            children: [
              {
                id: 'add-0FBA79A0-9D17-4918-AFCA-12DC16CD',
                documentId: '5011',
                documentName: 'หนังสือติดตามงาน',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '5',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-BFC1FFC7-0767-4A22-A07E-7A264221',
                documentId: '5012',
                documentName: 'หนังสือขอขยายระยะเวลา/เปลี่ยนแปลงโครงการ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '5',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-10782AF7-BAA8-4E9A-BE31-0337102A',
                documentId: '5088',
                documentName: 'เอกส่ารแนบประกอบอื่น',
                documentFileName: null,
                documentFilePath: null,
                documentType: '0',
                documentTypeName: 'ระบบ',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '5',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'add-FDAF2307-14F8-4738-8C47-2215CBA1',
                documentId: '5099',
                documentName: 'แนบเอกสารอื่นเพิ่มเติม',
                documentFileName: null,
                documentFilePath: null,
                documentType: '9',
                documentTypeName: 'แนบเพิ่มเติม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '5',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'last',
                documentId: '5099',
                documentName: '',
                documentFileName: '',
                documentFilePath: '',
                documentType: '',
                documentTypeName: '',
                documentStatusCode: '',
                documentStatusName: '',
                masterCategoryId: '5',
                isEdit: false,
                isLastRow: true,
              },
            ],
          },
          {
            id: '6',
            category: '09-การกำกับติดตาม/ประเมินผล/ตรวจสอบ',
            children: [
              {
                id: 'add-CA5DE0FA-7D2C-47DD-B65E-194E9B10',
                documentId: '9011',
                documentName: 'รานงาน IAP -10 ',
                documentFileName: null,
                documentFilePath: null,
                documentType: '1',
                documentTypeName: 'แนบเพิ่ม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '6',
                isEdit: true,
                isLastRow: false,
              },
              {
                id: 'add-5DD3EFB1-394C-41C3-919C-5EACE918',
                documentId: '9099',
                documentName: 'แนบเอกสารอื่นเพิ่มเติม',
                documentFileName: null,
                documentFilePath: null,
                documentType: '9',
                documentTypeName: 'แนบเพิ่มเติม',
                documentStatusCode: null,
                documentStatusName: null,
                masterCategoryId: '6',
                isEdit: false,
                isLastRow: false,
              },
              {
                id: 'last',
                documentId: '9099',
                documentName: '',
                documentFileName: '',
                documentFilePath: '',
                documentType: '',
                documentTypeName: '',
                documentStatusCode: '',
                documentStatusName: '',
                masterCategoryId: '6',
                isEdit: false,
                isLastRow: true,
              },
            ],
          },
        ],
      },
    },
  },
}
